import React from 'react';
import { Link } from 'react-router-dom';

import ScrollArea from '../scrollbar';

import { appConstants } from "../../../_constants";
import { appHelpers } from "../../../_helpers";


import './style.css';
import SuperAdminMenuComponent from "./menu/superAdmin";
import BSPMenuComponent from "./menu/bsp";
import AdminMenuComponent from "./menu/admin";
import VGGUserMenuComponent from "./menu/vgg_user";
import AirlineAdminMenuComponent from "./menu/airline_admin";
import AirlineStaffMenuComponent from "./menu/airline_staff";
import StaffMenuComponent from "./menu/staff";
import NcaaLogo from "../../../../src/views/pages/assets/logo-ncaa.png";
import Logo from "../../../../src/views/pages/assets/logo.png";

const NavHead = (props) => (
    <header className="nav-head">
        <Link to="/">
            <div style={{ float: 'left' }}>
                <img src={Logo} alt="NCAA AviCollect" height="40px" style={{ marginTop: '-10px' }} />
            </div>
            <div style={{ float: 'right' }}>
                <img src={NcaaLogo} alt="NCAA AviCollect" height="40px" style={{ marginTop: '-10px' }} />
            </div>

            &nbsp;&nbsp;

        </Link>
        {/*<div className={`toggle-dot ${props.mini ? 'active': ''}`} onClick={props.toggleNav}></div>*/}
    </header>
);





class NavList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
            activeUser: null
        }
    }
    componentWillMount() {
        this.setState({ activeUser: appHelpers.getActiveUser() });
        const queryString = window.location.href.split('/');
        const queryLength = queryString.length;
        const page_url = (queryLength > 4) ? queryString[queryLength - 2] : queryString[queryLength - 1];
        let selected = 0;
        let url_check = appConstants.PAGES_INDEX.find(item => item.name === page_url);
        if (url_check)
            selected = url_check.index;
        this.setState({ selected });
    }
    handleClick = (index, e) => {
        let c = e.currentTarget.className;
        e.preventDefault();
        e.stopPropagation();

        if (index === 1) {
            const url_ = appConstants.DATA_ENTRY_URL + appHelpers.getActiveUser().access_token;
            window.open(url_, '_blank');
        }
        this.setState({
            selected: (c.indexOf('selected') >= 0) ? '' : index
        })
    };
    handleDataEntry = (e) => {
        e.preventDefault();
        const url_ = appConstants.DATA_ENTRY_URL + appHelpers.getActiveUser().access_token;
    window.open(url_, '_blank');
    };
    handleOpen = (index, e) => {
        e.stopPropagation();
        this.setState({
            selected: index
        })
    };
    render() {
        const { activeUser } = this.state;
        const userRole = activeUser.AviRole;
        return <ScrollArea className="nav-list-container" horizontal={false} verticalScrollbarStyle={{ width: '4px', marginLeft: '10px' }}>
            {(userRole === appConstants.ROLES.BSP_ADMIN) &&
                <BSPMenuComponent handleClick={this.handleClick} selected={this.state.selected} handleOpen={this.handleOpen} handleDataEntry={this.handleDataEntry} />
            }
            {(userRole === appConstants.ROLES.SUPER_ADMIN || userRole === appConstants.ROLES.VGG_ADMIN) &&
                <SuperAdminMenuComponent handleClick={this.handleClick} selected={this.state.selected} handleOpen={this.handleOpen} handleDataEntry={this.handleDataEntry} />
            }
            {(userRole === appConstants.ROLES.ADMIN || userRole === appConstants.ROLES.NCAA_DATR) &&
                <AdminMenuComponent handleClick={this.handleClick} selected={this.state.selected} handleOpen={this.handleOpen} handleDataEntry={this.handleDataEntry} />
            }
            {(userRole === appConstants.ROLES.AIRLINE_ADMIN) &&
                <AirlineAdminMenuComponent handleClick={this.handleClick} selected={this.state.selected} />
            }
            {(userRole === appConstants.ROLES.AIRLINE_STAFF) &&
                <AirlineStaffMenuComponent handleClick={this.handleClick} selected={this.state.selected} />
            }
            {(userRole === appConstants.ROLES.STAFF) &&
                <StaffMenuComponent handleClick={this.handleClick} selected={this.state.selected} handleOpen={this.handleOpen} />
            }

            {(userRole === appConstants.ROLES.VGG_SUPERADMIN || userRole === appConstants.ROLES.VGG_USER) &&
                <VGGUserMenuComponent handleClick={this.handleClick} selected={this.state.selected} handleOpen={this.handleOpen} />
            }

            {/* end scroll-area */}
        </ScrollArea>
    }
}




export default (props) => (
    <nav className={`site-nav ${props.mini ? 'mini' : ''}`}>
        <NavHead {...props} />
        <NavList />

    </nav>
);



// WEBPACK FOOTER //
// ./src/shared/components/nav/index.js